module.exports = __webpack_public_path__ + "img/selected4-min.9ec65f88.png";